export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5616.cca0615f.jpg";